var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1142.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 1142.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3055 12709 c-154 -49 -372 -119 -485 -155 -113 -36 -216 -69 -230 -74 -21 -7 -140 -45 -535 -171 -1066 -339 -1739 -559 -1737 -569 1 -6 819 -1164 1816 -2573 997 -1409 1819 -2571 1826 -2583 12 -20 -125 -216 -1846 -2645 l-1859 -2624 -3 -105 -3 -105 243 -89 c218 -79 1987 -730 2248 -826 527 -195 510 -190 585 -190 l70 0 1279 1891 c767 1133 1283 1886 1288 1881 5 -5 559 -855 1231 -1888 l1222 -1879 70 -3 c68 -3 84 2 440 128 204 73 444 158 535 190 91 32 332 118 535 190 204 72 483 171 620 220 138 49 378 134 535 190 157 56 338 120 402 143 l118 41 0 101 0 101 -1846 2594 c-1016 1427 -1858 2612 -1871 2632 l-25 36 1788 2564 c983 1410 1795 2575 1805 2589 l18 25 -82 28 c-45 15 -199 68 -342 116 -415 141 -842 286 -1090 370 -126 43 -468 159 -760 258 -291 99 -597 203 -679 231 -126 43 -160 51 -220 50 l-71 0 -1161 -1752 c-639 -963 -1165 -1752 -1170 -1753 -5 -2 -509 786 -1120 1749 l-1112 1752 -73 2 c-69 2 -94 -4 -354 -88z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.3d4e1f99f4b5df67d607d9194be24a80.svg";
export { ForwardRef as ReactComponent };